import { showUIToast } from "../../ui/UIToast";

const handleValidationResult = (isValid: boolean, message: string): boolean => {
  showUIToast({ type: "error", text: message });
  return isValid;
};

export { handleValidationResult };
